import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

export const Lock: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(4.8, 4.8, props)}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4 16.243c0-6.96 5.641-12.6 12.6-12.6s12.6 5.64 12.6 12.6v3.4H41v22.666H7V19.643h4.4v-3.4Zm20.4 0v3.4H16.2v-3.4a7.8 7.8 0 0 1 15.6 0ZM21.6 27.009v7.934h4.8v-7.934h-4.8Z"
            fill="#fff"
        />
    </svg>
);
